<div class="container-fluid">
    
    <h4 id="upper">Acteurs</h4>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div>
              <!--  -->
              <a href="javascript:void(0);" class="btn btn-success mb-2" id="gras" (click)="openModal()">
                <i class="mdi mdi-plus me-2"></i> Ajouter un acteur
              </a>
            </div>
            <div class="row mb-md-2">
              <div class="col-sm-12 col-md-6">
            
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end"><label class="d-inline-flex align-items-center">Rechercher:
                    <input type="text" name="searchTerm" (keyup)="fiterActeur()"  [(ngModel)]="searchTerm"  class="form-control form-control-sm ms-2" aria-controls="tickets-table"></label></div>
              </div>
              <!-- End search -->
            </div>
            <div class="table-responsive mt-3">
              <table class="table table-centered datatable dt-responsive nowrap" style="border-collapse: collapse; border-spacing: 0; width: 100%;">
                <thead class="thead-light rwd-table">
                  <tr>
                    <th> Raison sociale</th>
                    <th>Identité du promoteur</th>
                    <th>Description </th>
                    <th>Secteur D'activité</th>
                    <th>Accréditation</th>
                      <th></th> 
                  </tr>
                </thead>
                <tbody>
                  <tr  *ngFor="let item of paginatedProjets; let index = index">
                
                    <td>{{item?.nom}}</td>
                    <td>{{item?.prenoms }}</td>
                    <td>{{item?.description}}</td>
                    <td>{{item?.secteur_activite}}</td>
                    <td>{{item?.numero_autorisation_exploitation}}</td>
                    <td>
                      <a (click)="EditModal(item)" style="cursor: pointer;" class="me-3 text-primary" v-b-tooltip.hover title="Modifier">
                        <i class="mdi mdi-pencil font-size-18"></i>
                      </a>
                      <a (click)="confirm1(item.reference)"  href="javascript:void(0);" class="text-danger" v-b-tooltip.hover title="Supprimer">
                        <i class="mdi mdi-trash-can font-size-18"></i>
                      </a>
                    </td>
                  </tr>
                  
                </tbody>
              </table>
            </div>
          </div>

          <div class="d-flex justify-content-center" *ngIf="actionData.length === 0 && isLoading===true">
            <div class="container">
                <div class="row">
                    <div class="text-center">
                        <h4 id="graycolor">Chargement en cours</h4>
                        <div class="loader4"></div>
                    </div>
                </div>
            </div>
          </div>
          <div class="d-flex justify-content-center" *ngIf="actionData.length === 0 && isLoading===false">
            <div class="container">
                <div class="row">
                    <div class="text-center">
                        <h4 id="graycolor">Aucune donnée trouvée</h4>
                    </div>
                </div>
            </div>
          </div>
        <p-paginator (onPageChange)="onPageChangeProjets($event)" [first]="firstProjets" [rows]="rowsProjets"
        [totalRecords]="totalRecords" [rowsPerPageOptions]="[10, 20, 30]">
      </p-paginator>
        </div>
      </div>
    </div>
  </div>
  


  <p-confirmDialog />
  <p-toast />
  <ngx-ui-loader></ngx-ui-loader>
 